/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { LocationStrategy } from '@angular/common'
import { Component, EventEmitter, Output, ViewEncapsulation, inject, signal, ChangeDetectionStrategy } from '@angular/core'
import { ModalTexts } from './modal-texts'

@Component({
  selector: 'pidx-myprofile-pds-modal-wrapper',
  templateUrl: './pidx-pds-modal-wrapper.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: ['.footer { padding-top: 2rem; }'],
  standalone: false,
  // Angular 22 changed the implicit default to OnPush (see angular/angular#67687). This component was never migrated
  // to OnPush semantics, so Eager restores the pre-v22 behaviour it relies on.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PidxPdsModalWrapperComponent {
  private location = inject(LocationStrategy)

  data = signal<ModalTexts>({})
  openModal = signal<boolean>(false)

  @Output() closeModalEvent = new EventEmitter<boolean>()

  constructor() {
    history.pushState(null, '', window.location.href)
    // check if back or forward button is pressed.
    this.location.onPopState(() => {
      if (this.openModal() === true) {
        history.pushState(null, '', window.location.href)
      }
      this.closeModal(false)
    })
  }

  closeModal(choice: boolean) {
    this.openModal.set(false)
    this.closeModalEvent.emit(choice)
  }
}
